import { createAsyncThunk } from '@reduxjs/toolkit';

import { FormStepId } from 'shared/config/formStepId';

import type { TCreditFormState } from 'entities/creditForm';
import { selectStepsFields } from 'entities/creditForm';
import type { TUserState } from 'entities/user/model/user.selectors';
import { accountSelector } from 'entities/user/model/user.selectors';

import { sendCustomerDataThunk } from 'features/SendCustomerData';

export const updateUserLandingDataThunk = createAsyncThunk<void, void, { state: TCreditFormState & TUserState }>(
  'updateUserData/updateUserLandingDataThunk',
  async (_, { dispatch, getState }) => {
    const user = accountSelector(getState());

    if (!user) {
      return;
    }

    dispatch(
      sendCustomerDataThunk(selectStepsFields([FormStepId.CreditPurposeInfo, FormStepId.ContactsInfo])(getState())),
    );
  },
);
